import React from 'react';
import { message, DatePicker, Modal } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import moment from 'moment';

const { RangePicker } = DatePicker;
const dateFormat = 'YYYY-MM-DD'; 
class BacthHandle extends React.Component {
    state = {
        visible: false,
        beginDate: null,
        endDate: null,
    }

    show = () => {
        this.setState({  visible: true })
    }

    hide = () => {
        this.setState({  
            visible: false,
            beginDate: null,
            endDate: null
        })
    }

    handle = () => {
        const { beginDate, endDate } = this.state;
        this.props.handleComplate({ markType: 'ALL', beginDate, endDate })
        this.props.loadData()
        this.hide()
    }

    onChange = (date, dateString= []) => {
        this.setState({ beginDate:dateString[0] , endDate:dateString[1] })
    }

    render() {
        const { loading, visible, beginDate, endDate,} = this.state;
        return (
            <Modal
                title="批量标记为已处理"
                visible={visible}
                onOk={this.handle}
                onCancel={this.hide}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                maskClosable={false}
                width="400px"
            >
                <div style={{ padding: '30px 40px',  }}>
                    <div style={{display: 'flex'}}>
                        <label style={{ lineHeight: '28px', margin: '0 20px 10px 0' }}>时间范围</label>
                        <div style={{ width: '70%' }}>
                            <RangePicker 
                            format={dateFormat}
                            value={[
                                beginDate ? moment(beginDate, dateFormat) : null, 
                                endDate ? moment(endDate, dateFormat) : null
                            ]} 
                            onChange={this.onChange} />
                        </div>
                    </div>
                    <p style={{ color: '#fda523' }}>
                        注意：若未选择时间范围直接点击确认按钮，将删除所有待办事项
                    </p>
                </div>
            </Modal>

        );
    }
}

export default BacthHandle;



// WEBPACK FOOTER //
// ./src/components/layout/notice/BacthHandle.js